import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type GroupProps = PropsWithChildren<{
    hint?: string;
    className?: string;
}>

export const Group = ({hint, className, children}: GroupProps) => {
    return (
        <div
            title={hint}
            className={twMerge("mb-3", className)}>
            {children}
        </div>
    )
}
